import { Entity } from '@data-client/rest';
class NumberKeyValuePairEntity extends Entity {
    constructor() {
        super(...arguments);
        this.key = null;
        this.value = null;
    }
    pk() {
        var _a;
        return `${this.constructor.key}:${(_a = this.key) !== null && _a !== void 0 ? _a : ''}`;
    }
}
NumberKeyValuePairEntity.key = 'NumberKeyValuePair';
export { NumberKeyValuePairEntity };
class EncryptionsAccessLogDeviceTypeEntity extends NumberKeyValuePairEntity {
}
EncryptionsAccessLogDeviceTypeEntity.key = 'EncryptionsAccessLogDeviceType';
export { EncryptionsAccessLogDeviceTypeEntity };
